export const sources = {
};
export const img = {
	src: "__VITE_ASSET__xUfAOc8vsLn5godiQWqFgA__",
	w: 420,
	h: 420
};
export default {
	sources: sources,
	img: img
};
